var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('page-header'),(_vm.deviceType == 'pc')?_c('home-pc'):_vm._e(),(_vm.deviceType == 'mobile')?_c('home-mobile'):_vm._e(),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }